<template>
  <div class="component_container">
    <!-- <div class="title_box">
      <img class="column_highlight_img" src="../assets/images/column_highlight.png" alt="" />
      活跃用户情况
      <div class="category_box">
        <div class="category">
          <span class="circle"></span>日活跃用户
        </div>
        <div class="category">
          <span class="circle right_circle"></span>活跃用户
        </div>
      </div>
    </div>
    <div class="statistics_box">
      <div class="statistics_item"> 
        <div class="statistics_title">活跃用户</div>
        <div class="statistics_value">
          <span class="count">{{activeUser}}</span>个
        </div>
      </div>
      <div class="statistics_item">
        <div class="statistics_title">日活跃用户</div>
        <div class="statistics_value">
          <span class="count">{{todayActiveUser}}</span>个
        </div>
      </div>
      <div class="statistics_item">
        <div class="statistics_title">月活跃用户</div>
        <div class="statistics_value">
          <span class="count">{{monthActiveUser}}</span>个
        </div>
      </div>
    </div> -->
    <div class="main_box">
      <div class="echarts_box">
        <div id="echarts10" style="height: 100%"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataObj: {
      type: Object,
      default: () => ({}),
    },
    allClassArr: {
      type: Array,
      default: () => ({}),
    },
  },
  data() {
    return {
      activeUser: 0,
      monthActiveUser: 0,
      todayActiveUser: 0,
    };
  },
  mounted() {
    this.renderEchartsMethod();
  },
  methods: {
    renderEchartsMethod() {
      console.log("渲染图标");
      let that = this;
      let myChart = this.$echarts.init(document.getElementById("echarts10"));
      myChart.off("click");
      let option = {
        xAxis: {
          type: "category",
          triggerEvent: true,
          axisLabel: {
            color: "#fff",
            fontSize: "14",
            interval: 0,
            formatter: function (params) {
              var newParamsName = ""; // 最终拼接成的字符串
              var paramsNameNumber = params.length; // 实际标签的个数
              var provideNumber = 2; // 每行能显示的字的个数
              var rowNumber = Math.ceil(paramsNameNumber / provideNumber); // 换行的话，需要显示几行，向上取整
              /**
               * 判断标签的个数是否大于规定的个数， 如果大于，则进行换行处理 如果不大于，即等于或小于，就返回原标签
               */
              // 条件等同于rowNumber>1
              if (paramsNameNumber > provideNumber) {
                /** 循环每一行,p表示行 */
                for (var p = 0; p < rowNumber; p++) {
                  var tempStr = ""; // 表示每一次截取的字符串
                  var start = p * provideNumber; // 开始截取的位置
                  var end = start + provideNumber; // 结束截取的位置
                  // 此处特殊处理最后一行的索引值
                  if (p == rowNumber - 1) {
                    // 最后一次不换行
                    tempStr = params.substring(start, paramsNameNumber);
                  } else {
                    // 每一次拼接字符串并换行
                    tempStr = params.substring(start, end) + "\n";
                  }
                  newParamsName += tempStr; // 最终拼成的字符串
                }
              } else {
                // 将旧标签的值赋给新标签
                newParamsName = params;
              }
              //将最终的字符串返回
              return newParamsName;
            },
          },

          axisTick: {
            alignWithLabel: true,
          },
          data: this.dataObj.name,
        },
        tooltip: {
          trigger: "axis",
          //
          formatter: function (data) {
            return (
              "服务类型" +
              "<br/>" +
              "<span style ='background:#196EFF;width:10px;height:10px; display: inline-block;border-radius: 50%;margin-right:5px'></span>" +
              data[0].axisValue +
              "：" +
              data[0].value
            ); //将小数转化为百分数显示
          },
        },
        dataZoom: [
          {
            type: "inside", //slider表示有滑动块的，inside表示内置的
            show: true,
            xAxisIndex: [0],
            start: 0,
            end: 40,
            startValue: 0,
            endValue: 80,
            zoomOnMouseWheel: false,
          },
        ],
        yAxis: {
          type: "value",
          color: "",
          min: 0,
          max: 80,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#FFFFFF", //这里用参数代替了
              fontSize: "14",
            },
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: "RGBA(12, 33, 52, 1)",
            },
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: "RGBA(12, 33, 52, 1)",
            },
          },
        },
        grid: {
          left: "0%",
          right: "10%",
          bottom: "2%",
          containLabel: true,
        },
        series: [
          {
            data: this.dataObj.count,
            type: "bar",
            barWidth: 12,
            // showBackground: true,
            backgroundStyle: {
              color: "rgba(180, 180, 180, 0.2)",
            },
            itemStyle: {
              normal: {
                color: this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#1AC0FF",
                  },
                  {
                    offset: 1,
                    color: "#184AFF",
                  },
                ]),
              },
            },
          },
        ],
      };

      myChart.setOption(option);
      myChart.on("click", function (e) {
        // console.log(e)
        let name;
        if (e.targetType == "axisLabel") {
          name = e.value;
        } else {
          name = e.name;
        }
        console.log(that.allClassArr);
        let arr = that.allClassArr.filter((item) => {
          return item.dictName.indexOf(name) >= 0;
        });
        console.log(arr);
        that.$router.push({
          path: "/orgTeam",
          query: {
            dictId: arr[0].dictId, // 二级分类Id，
            dictParentKey: arr[0].dictParentKey, // 一级分类 ID
          },
        });
      });
    },
    getDataMethod() {
      if (Object.keys(this.dataObj).length == 0) {
        return;
      }
      const {
        activeUser,
        monthActiveUser,
        todayActiveUser,
        weekActiveStaArr,
        weekDayActiveStaArr,
      } = this.dataObj;
      this.activeUser = activeUser;
      this.monthActiveUser = monthActiveUser;
      this.todayActiveUser = todayActiveUser;
      this.renderEchartsMethod(weekActiveStaArr, weekDayActiveStaArr);
    },
  },
};
</script>

<style lang="less" scoped>
.component_container {
  width: 100%;
  height: 100%;
  color: #fff;
  padding-top: 1px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}
.title_box {
  position: relative;
  height: 41px;
  line-height: 41px;
  padding-left: 14px;

  .column_highlight_img {
    position: absolute;
    width: 22px;
    height: 41px;
    left: -9px;
    top: 0;
  }

  .category_box {
    float: right;
    display: flex;
    .category {
      margin-right: 33px;
      .circle {
        display: inline-block;
        width: 12px;
        height: 12px;
        background: #4d118b;
        border-radius: 50%;
        margin-right: 9px;

        &.right_circle {
          background-color: #16d0ff;
        }
      }
    }
  }
}

.statistics_box {
  display: flex;
  margin-top: 10px;
  padding: 0 60px 0 47px;
  justify-content: space-between;
  .statistics_item {
    .statistics_title {
      line-height: 14px;
      font-size: 14px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #ffffff;
    }
    .statistics_value {
      margin-top: 7px;
      line-height: 18px;
      font-size: 18px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      .count {
        color: #f8e61d;
      }
    }
  }
}

.main_box {
  display: flex;
  flex-grow: 1;
  height: 100%;
  .echarts_box {
    flex-grow: 1;
    #echarts10 {
      width: 100%;
    }
  }
}
</style>
